module.exports = __webpack_public_path__ + "media/stylesheets/images/talentz/sec_change_img02-bb74fca2841191e626a0801a49d250f0.svg";